import { render, staticRenderFns } from "./QuestionDetails.vue?vue&type=template&id=98f2636e&scoped=true"
import script from "./QuestionDetails.vue?vue&type=script&lang=js"
export * from "./QuestionDetails.vue?vue&type=script&lang=js"
import style0 from "./QuestionDetails.vue?vue&type=style&index=0&id=98f2636e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f2636e",
  null
  
)

export default component.exports